import React from 'react';
import PropTypes from 'prop-types';
import { BUTTON_TYPES } from 'helpers/TypeHelper';
import Button from 'componentsV2/Button';
import {
  Events,
  getFavoritesProps,
  getSegmentFavoritesEvents,
  getSegmentModelMetadata,
  handleAnalytics,
} from '@foxcorp/delta-web-analytics';
import { useSelector } from 'react-redux';
import Style from './Favorite.module.scss';

const Favorite = props => {
  const { account } = useSelector(state => state.app);
  const { item, theme = {}, favoritableItems, manager, onClickHandler } = props;
  const [loading, setLoading] = React.useState(false);
  const trackHeroItemSelectAction = ({ item, isAddingFavorite = false }) => {
    handleAnalytics({
      event: Events.HERO_ITEM_SELECT_ACTION,
      payload: {
        page_action_type: `${isAddingFavorite ? 'add to' : 'remove from'} favorites`,
        page_collection_count: 1,
        page_item_type: 'hero',
        page_item_state: 'static image',
        page_item_container_title: item.name,
        page_item_vertical_position: '1',
        page_item_horizontal_position: '1',
        page_item_title: item.name,
        page_item_subtitle: item.description,
        page_item_cc: 'cc off',
        page_item_volume: 'volume off',
        page_playlist_length: 1,
        page_video_uid: item.latestEpisode?.uID,
        ...getSegmentModelMetadata(),
      },
    });
  };

  const setFavorites = e => {
    if (loading) return;
    setLoading(true);
    manager.setFavorites(item).then(() => {
      getSegmentFavoritesEvents().addFavorite({
        ...item,
        ...(manager.favorites && { favoritesProps: getFavoritesProps(manager.favorites) }),
      });
      trackHeroItemSelectAction({ item });
      setLoading(false);
    });
  };

  const deleteFavorites = e => {
    if (loading) return;
    setLoading(true);
    manager
      .deleteFavorites({ favoriteList: [item], favoritesDetails: manager.favoritesDetails })
      .then(() => {
        getSegmentFavoritesEvents().removeFavorite({
          ...item,
          ...(manager.favorites && { favoritesProps: getFavoritesProps(manager.favorites) }),
        });
        trackHeroItemSelectAction({ item });
        setLoading(false);
      });
  };

  const clickEvent = event => {
    event.stopPropagation();
    event.preventDefault();
    if (isFavoriteCheck()) {
      deleteFavorites(event);
    } else {
      setFavorites(event);
    }
    onClickHandler(event);
  };

  const isFavoriteCheck = () => {
    if (!manager || !manager.favorites) return false;
    const favoritableItem = favoritableItems ?? [];
    let results = [];

    favoritableItem.forEach(item => {
      const matches = manager.favorites.filter(favorite => item.id === favorite.favoriteID);
      results = [...matches, ...results];
    });
    return results.length > 0;
  };

  if (!account) return null;
  return (
    <>
      <Button
        type={BUTTON_TYPES.PERSONALITY_FAVORITE}
        label="Favorite"
        onClick={clickEvent}
        theme={{ ...Style, theme }}
        toggled={isFavoriteCheck()}
        primary
      />
    </>
  );
};

Favorite.defaultProps = {
  onClickHandler: () => {},
  item: {},
  theme: {},
};

Favorite.propTypes = {
  onClickHandler: PropTypes.func,
  item: PropTypes.shape({}),
  favoritableItems: PropTypes.shape({}),
  manager: PropTypes.shape({
    deleteFavorites: PropTypes.func,
    favorites: PropTypes.arrayOf(PropTypes.shape({})),
    setFavorites: PropTypes.func,
  }).isRequired,
  theme: PropTypes.shape({}),
};

export default Favorite;
